import {Injectable} from '@angular/core';

/**
 * Сервис для единой реализации скролла к элементу на странице
 */

@Injectable()
export class ScrollToService {
    /**
     * Подмотать к элементу target
     *
     * @param {HTMLElement} target
     */
    static to(target: HTMLElement) {
        if (!target) {
            return;
        }

        const offsetY = window.pageYOffset;
        const {top} = target.getBoundingClientRect();

        /**
         * Подматываем на 100px до цели, чтобы она не перекрывалась шапкой
         * @type {number}
         */
        const targetOffset = offsetY + top - 100;
        window.scrollTo(0, targetOffset);
    }

    static toById(id: string) {
        if (!id) {
            return;
        }

        const target = document.getElementById(id);

        if (!target) {
            return;
        }

        this.to(target);
    }

    static toIntoViewById(id: string) {
        if (!id) {
            return;
        }

        const target = document.getElementById(id);

        if (!target || !target.scrollIntoView) {
            return;
        }

        target.scrollIntoView();
    }

    static toTop() {
        window.scrollTo(0, 0);
    }
}
